var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"150"}},[_c('v-footer',{staticClass:"font-weight-medium",attrs:{"absolute":"","color":"white"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" © 2020 - "),_c('strong',[_vm._v("Instituto Pró-Hemoce")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }